import React from "react";
import flashLogo from "assets/img/flash-logo.png";
import { getPackageBenefits } from "../CallLeadDetails.utils";

const PackageDetails = ({ item, isBasicUser }) => {
  const packageData = item.catalogue_package || {};
  const benefits = getPackageBenefits(item.lead_catalogue_package_feature);

  return (
    <li className="cw-package-item">
      <div className="cw-package-heading">
        <img
          className="cw-package-logo"
          src={packageData.package_logo || flashLogo}
          alt={packageData.title || "Flash Health"}
        />
        <div className="cw-package-content">
          <strong className="cw-package-name">
            {packageData.title || "Package"}
          </strong>
          {!isBasicUser ? (
            <span className="cw-package-dates">
              {item.package_start_date || item.start_date || item.startDate || ""}
              {item.package_end_date || item.end_date || item.endDate
                ? " – " +
                  (item.package_end_date || item.end_date || item.endDate)
                : ""}
            </span>
          ) : null}
        </div>
      </div>
      {!isBasicUser && benefits.length ? (
        <ul className="cw-package-benefits">
          {benefits.map((benefit) => (
            <li className="cw-package-benefit" key={benefit.key}>
              {benefit.text}
            </li>
          ))}
        </ul>
      ) : null}
    </li>
  );
};

export default PackageDetails;
